export class EntrySearchOptionsModel {
    constructor() {
        this.search = [];
        this.multiSearch = [];
    }
}
export default class EntrySearchOptions extends EntrySearchOptionsModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
